import { useEffect, useRef, useState } from 'react';
import type * as monaco from 'monaco-editor';
import monacoDiffEditor from './monacoDiffEditor';
import { EditorProps } from './types';

type MonacoEditorInstance = {
  instance: monaco.editor.IStandaloneDiffEditor;
  monaco: typeof monaco;
};

const DiffEditor = ({
  currentValue,
  previousValue,
  colormode,
}: EditorProps) => {
  const htmlRef = useRef<HTMLDivElement>(null);
  const monacoRef = useRef<MonacoEditorInstance>(undefined);
  const initRef = useRef<boolean>(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (initRef.current || !htmlRef.current) {
      return;
    }
    initRef.current = true;
    monacoRef.current = monacoDiffEditor({
      ref: htmlRef.current,
      options: {
        readOnly: true,
        autoIndent: 'full',
        automaticLayout: true,
        fontSize: 14,
        padding: {
          top: 12,
        },
      },
    });
    const previous = monacoRef.current.monaco.editor.createModel(previousValue);
    const current = monacoRef.current.monaco.editor.createModel(currentValue);

    monacoRef.current.instance.setModel({
      original: previous,
      modified: current,
    });

    setMounted(true);
  }, []);

  useEffect(() => {
    if (monacoRef.current) {
      const theme = colormode === 'dark' ? 'vs-dark' : 'vs';
      monacoRef.current.monaco.editor.setTheme(theme);
    }
  }, [colormode, mounted]);

  return (
    <div
      style={{
        maxWidth: '100%',
        width: '100%',
        maxHeight: '100vh',
        height: '100%',
      }}
      ref={htmlRef}
    ></div>
  );
};

export default DiffEditor;
